namespace $.$$ {

	$mol_style_define( $shm_ba_converter, {
		gap: $mol_gap.block,

		Limit_row: {
			alignItems: 'center',
			gap: $mol_gap.text,
			flexWrap: 'wrap',
		},

		Limit_label: {
			color: $mol_theme.shade,
			font: {
				weight: 'bold',
			},
		},

		Limit: {
			width: '160px',
		},

		Format_row: {
			gap: $mol_gap.text,
			flexWrap: 'wrap',
		},
	} )

}
